import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'iview/dist/styles/iview.css';

import {  Modal, Message } from "iview";

Vue.prototype.$Modal = Modal
Vue.prototype.$Message = Message
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
